import { Guest } from "./Guest";
import { Room } from "./Room";

export interface Reservation {
  reservationId: number;

  dietaryPreference?: string;     // e.g., Vegetarian, Vegan, Gluten-Free
  arrivalTime?: string;           // e.g., "14:30"
  remarks?: string;
  pickupRequired?: boolean;

  /* =========================
     PROPERTY / LOCATION
  ========================== */
  propertyId: number;                 // hotelId (REQUIRED)
  propertyName?: string;              // hotelName (UI)
  propertyLocation?: string;          // city / address
  accountingDate?: string;            // DatePicker value

  /* =========================
     GUEST
  ========================== */
  guestId: number;                    // 0 = new guest
  guestName?: string;
  phoneNumber?: string;
  email?: string;

  guest?: Guest;
  guests?: Guest[];                   // group booking display

  travelAgent?: string;
  booker?: string;
  company?: string;

  /* =========================
     GROUP RESERVATION
  ========================== */
  groupCode?: string;
  groupName?: string;
  groupReservationId?: number;

  /* =========================
     ROOM
  ========================== */
  roomId: number;
  roomTypeId?: number;
  roomTypeName?: string;              // UI display only

  room?: Room;

  /* =========================
     STAY
  ========================== */
  checkInDate: string;
  checkOutDate: string;
  numberOfNights?: number;

  numberOfAdults: number;
  numberOfChildren: number;
  numberOfInfants: number;

  walkIn?: boolean;
  purposeOfStay?: string;

  /* =========================
     STATUS / PAYMENT
  ========================== */
  status: string;
  totalAmount: number;
  transactionId?: string;
  specialRequests?: string;

  /* =========================
     DEMOGRAPHY (OPTIONAL)
  ========================== */
  age?: number;
  gender?: string;
  occupation?: string;
  maritalStatus?: string;

  /* =========================
     METADATA
  ========================== */
  dateAdded?: string;
  updatedAt?: string;
}


export const initializedReservation: Reservation = {
  reservationId: 0,

  dietaryPreference: "",
  arrivalTime: "",
  remarks: "",
  pickupRequired: false,
  propertyId: 0,
  propertyName: "",
  propertyLocation: "",
  accountingDate: new Date().toISOString(),

  guestId: 0,
  guestName: "",
  phoneNumber: "",
  email: "",

  travelAgent: "",
  booker: "",
  company: "",

  groupCode: "",
  groupName: "",

  roomId: 0,

  checkInDate: new Date().toISOString(),
  checkOutDate: new Date().toISOString(),
  numberOfNights: 0,

  numberOfAdults: 1,
  numberOfChildren: 0,
  numberOfInfants: 0,

  walkIn: false,

  status: "Pending",
  totalAmount: 0,

  specialRequests: "",
};
